import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Button,
    Checkbox,
    Container,
    FormControlLabel,
    Grid2,
    IconButton,
    InputAdornment,
    MenuItem,
    OutlinedInput,
    Paper,
    Select as MuiSelect,
    TextField,
    Tooltip,
    Typography,
} from "@mui/material";
import {Field, Form, Formik} from "formik";
import React, {Fragment, useEffect, useRef, useState} from "react";

import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import Select from "components/common/Select";

import {green, red} from "@mui/material/colors";
import {makeStyles, withStyles} from "@mui/styles";
import AtsTooltip from "components/common/AtsTooltip";
import ConfirmDialog from "components/common/ConfirmDialog";
import { default as FilmReleaseSelect2 } from "components/global/FilmReleaseSelect";
import FullScreenModal from "components/common/FullScreenModal";
import {sortArrayByDate} from "components/common/utils";
import {FilmCardView} from "components/film/index";
import {actions as globalActions} from "components/global/logic/actions";
import {actions as loginActions} from "components/login/logic/actions";
import AddReviewForm from "components/review/AddReviewForm";
import {ACTION_STATES} from "core/actions";
import {assertArray, assertString} from "core/validation";
import {cloneDeep, get, isEmpty, isNumber} from "lodash";
import log from "loglevel";
import {connect, useSelector} from "react-redux";
import {API_URL} from "services";
import AdvertisingService from "services/advertisingService";
import {styles} from "../AdvDetails/styles";
import {actions, advFormDefaultValues} from "../logic/formActions";
import "./styles.scss";
import {AddNewAdvFromExisting, DeleteAdvBtn} from "components/advertising/commonComponents";
import {Paths} from "components/common/navigation";
import {RelatedTable} from "components/relatedFilms";
import {actions as reportAdvActions} from "components/report/advertising/logic/advReportActions";
import {ATTRIBUTE_TYPE_IDS, REVIEW_STATUS_EMPTY_ID} from "core/dataConstants";
import {useNavigate} from "react-router-dom";
import {toast} from "react-toastify";
import {advTypesSelector} from "../../global/logic/actions";
import {DATE_FORMAT_TEXT_INPUT, formatDate, DATE_FORMAT_HOUR_AM_PM, DATE_FORMAT_ZONE_TIME_LONG} from "components/common/dateUtils";
import {handleServerErrors} from "core/exceptions";

const useStyles = makeStyles(styles);

const GreenCheckbox = withStyles({
    root: {
        color: green[400],
        "&$checked": {
            color: green[600],
        },
    },
    checked: {},
})((props) => <Checkbox color="default" {...props} />);

const RedCheckbox = withStyles({
    root: {
        color: red[400],
        "&$checked": {
            color: red[600],
        },
    },
    checked: {},
})((props) => <Checkbox color="default" {...props} />);

const AddAdvertisingForm = (props) => {
    const {
        addAdv,
        advertisingFormOpen,
        toggleAdvertisingForm,
        editAdv,
        editing,
        filmCodeTypes,

        getAttributeTypes,

        initValues,
        user,
        refreshTable,
        addStatus,
        editStatus,
        addToReportById,
        onRefresh,
        isForReport,
        onCleanForm,
    } = props;


    const classes = useStyles();
    const navigate = useNavigate();


    const advertisementTypes = useSelector(advTypesSelector);

    const defaultFilmRelease =
        initValues && initValues.filmRelease && initValues.filmRelease.id ? initValues.filmRelease : null;


    const [reviewsToAdd, setReviewsToAdd] = useState([]);
    const [attrs, setAttrs] = useState({});
    const [contacts, setContacts] = useState([]);
    const [filmRelease, setFilmRelease] = useState(null);
    const [reported, setReported] = useState(false);
    const [exception, setException] = useState(false);
    const [reviewSelected, setReviewSelected] = useState(null);
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
    const [advId, setAdvId] = useState(null);
    const [associations, setAssociations] = useState(initValues.associations);
    const [formChanged, setFormChanged] = useState(false);
    const [reviewFormChanged, setReviewFormChanged] = useState(false);
    const [reportAfterSend, setReportAfterSend] = useState(false);

    const formRef = React.useRef();

    const reviewFormRef = useRef();


    const advTypes = advertisementTypes.map((type) => ({ value: type.id, label: type.name }));
    const reviewList = sortArrayByDate(reviewsToAdd, "dateEntered", true);

    useEffect(() => {
        setAssociations(initValues.associations);
    }, [initValues.associations]);

    useEffect(() => {
        getAttributeTypes();
    }, []);

    useEffect(() => {
        log.debug("initvalues****************", initValues);
        if (initValues.id) {
            setAdvId(initValues.id);
            if (assertArray(initValues.codeValueList)) {
                formRef.current.setFieldValue("codeValue", initValues.codeValueList[0].codeValue);
            }
        }
        if (initValues.attributes) {
            setAttrs(initValues.attributes);
        }
        setReported(!!initValues.reported);
        setException(!!initValues.exception);

        if ((editing && initValues.filmRelease.id) || (initValues.filmRelease && initValues.filmRelease.id)) {
            setFilmRelease({ ...initValues.filmRelease });
            AdvertisingService.getFilmReleaseById(initValues.filmRelease.id).then((response) => {
                setFilmRelease(response.data);
            });
        }
    }, [initValues.attributes]);

    useEffect(() => {

        if (initValues.reviews) {
            setReviewsToAdd(initValues.reviews);
            const reviewsSorted = sortArrayByDate(initValues.reviews, "dateEntered", true);
            if (reviewsSorted.length > 0 && !reviewSelected) {
                setReviewSelected(reviewsSorted[0]);
            }
        }
    }, [initValues.reviews]);

    useEffect(() => {
        if (addStatus === ACTION_STATES.FAILED || editStatus === ACTION_STATES.FAILED) {
            showToastError();
        }
    }, [addStatus, editStatus]);

    const onReviewChanged = async () => {
        if (editing && (!formChanged || !reviewFormChanged)) {
            setFormChanged(true);
            setReviewFormChanged(true);
        }
    };
    function handleOnAddToReport() {
        setReportAfterSend(true);
        formRef.current.submitForm();
    }

    const onReviewReset = () => {
        setReviewSelected(null);
    };

    function resetFormCallback(resetForm) {
        onCleanForm();
        setAttrs({});
        setReported(false);
        setException(false);
        setReviewsToAdd([]);
        setFilmRelease(null);
        setReviewSelected(null);
        if (reportAfterSend) {
            addToReportById(initValues.id);
            navigate(Paths.ADV_REPORT);
        } else {
            if (isForReport) {
                onRefresh();
            } else {
                refreshTable();
            }

            log.debug(formRef);
            if (resetForm) {
                resetForm();
            } else if (formRef && formRef.current) {
                formRef.current.resetForm();
                formRef.current.setValues({ fields: advFormDefaultValues });
            }
        }
    }

    function cloneFormCallback(resetForm) {
        setReviewsToAdd([]);
        setFilmRelease(null);
        setReviewSelected({
            ...reviewSelected,
            privateNote: reviewSelected ? `${reviewSelected.privateNote} <p>*** Cloned from ${filmRelease.title}</p>` : `<p>*** Cloned from ${filmRelease.title}</p>`,
        });
        if (reportAfterSend) {
            addToReportById(initValues.id);
            navigate(Paths.ADV_REPORT);
        } else {
            if (isForReport) {
                onRefresh();
            } else {
                refreshTable();
            }

            log.debug(formRef);
            if (resetForm) {
                resetForm();
            } else if (formRef && formRef.current) {
                formRef.current.resetForm();
                formRef.current.setValues({ fields: advFormDefaultValues });
            }
        }
    }

    const handleFullScreenClose = (resetForm) => {
        const isDirtyReview = reviewFormRef.current.isDirty();
        const isDirtyAdv = formRef.current.dirty;
        if (editing && (isDirtyReview || isDirtyAdv)) {
            setConfirmDialogOpen(true);
        } else {
            toggleAdvertisingForm();
            resetFormCallback(resetForm);
        }
    };

    function closeConfirmation(resetForm) {
        setConfirmDialogOpen(false);
        setFormChanged(false);
        toggleAdvertisingForm();
        resetFormCallback(resetForm);
    }
    const handleConfirmDialogClose = (resetForm, submitForm) => {
        setConfirmDialogOpen(false);
        setFormChanged(false);
        if (submitForm) submitForm();
        else handleFullScreenClose(resetForm);
    };

    const formatReviewToSubmit = (review) => {
        return {
            ...review,
            viewerIds:review.viewers?.length > 0 ? review.viewers.map(v => v.value) : [],
            dateEntered: formatDate(review.dateEntered, DATE_FORMAT_ZONE_TIME_LONG),
            reviewMinutes: review.reviewMinutes ? review.reviewMinutes : null,
            reviewStatusTypeID:
                review.reviewStatusType && review.reviewStatusType.value
                    ? review.reviewStatusType.value
                    : REVIEW_STATUS_EMPTY_ID,


            tagIds:assertArray(review.tagIds) ?  review.tagIds.map((item) => {
                if (Number.isInteger(parseInt(item))) return item;
                return item.value;
            }) : [],
            userID: user?.id,
        };
    };

    function handleOnSubmit(values, { resetForm }) {
        try {
            const newReview = cloneDeep(reviewFormRef.current.getValues());

            const isNewReviewToAdd = Object.values(newReview).find((v) => !isEmpty(v) || isNumber(v));

            let _reviews;

            if (isNewReviewToAdd && (!editing || reviewFormChanged)) {
                _reviews = [newReview, ...reviewsToAdd].map(formatReviewToSubmit);
            } else {
                _reviews = reviewsToAdd.map(formatReviewToSubmit);
            }

            const _newReview = sortArrayByDate(
                _reviews.filter((r) => !r.id),
                "dateEntered",
                true
            );
            const oldReviews = sortArrayByDate(
                _reviews.filter((r) => r.id),
                "dateEntered",
                true
            );

            const reviews = [];
            if (assertArray(_newReview)) {
                reviews.push(..._newReview);
            }
            if (assertArray(oldReviews)) {
                reviews.push(...oldReviews);
            }

            const attributeList = Object.entries(attrs)
                .filter((entry) => entry[1].active)
                .map((entry) => {
                    const attr =
                        initValues.attributeList &&
                        initValues.attributeList.find((attr) => attr.attributeTypeId === entry[0]);
                    return {
                        ...attr,
                        attributeTypeId: entry[0],
                        attributeValue: entry[1].value || "true",
                    };
                });

            let codeValueList = values.codeValueList || initValues.codeValueList || [];

            if (!assertArray(codeValueList) && assertString(values.codeValue) && assertArray(filmCodeTypes)) {
                const code = filmCodeTypes[0];
                codeValueList = [
                    {
                        ...code,
                        value: code.id,
                    },
                ];
            }
            const newAdv = {
                ...initValues,
                quantity: values.quantity || 1,
                advertisementTypeID:
                    (values.advertisementType && values.advertisementType.value) || initValues.advertisementTypeID,
                attributeList,
                codeValueList: codeValueList
                    .filter((v) => !!v)
                    .map((codeValue) => {
                        return {
                            ...codeValue,
                            codeTypeID: codeValue.value,
                            codeValue: values.codeValue,
                        };
                    }),
                contactID: (values.contact && values.contact.value) || (initValues.contact && initValues.contact.value),
                exception,
                filmReleaseID: values.filmRelease.id || (initValues.filmRelease && initValues.filmRelease.value),
                name: values.name || initValues.name,
                reported,
                reviews,
                userID: user?.id,
            };
            log.debug(newAdv);

            if (!editing) {
                const refreshViewPage = initValues.refreshViewPage;
                const callback = (redirectId) => {
                    log.debug("saving success adv callback");
                    toast.success("The advertisement has been saved successfully.");
                    if (reportAfterSend) {
                        addToReportById(redirectId);
                        navigate(Paths.ADV_REPORT);
                    } else {
                        log.debug("redirecting", refreshViewPage, redirectId);
                        if (redirectId) {
                            navigate(Paths.ADVERTISING + "/" + redirectId);
                        }
                        resetFormCallback(resetForm);
                    }
                };
                if (reportAfterSend) {
                    newAdv.refreshViewPage = true;
                }
                addAdv(newAdv, callback);
            } else {
                editAdv(newAdv, () => {
                    log.debug("saving success adv callback");
                    toast.success("The advertisement has been saved successfully.");

                    resetFormCallback(resetForm);
                });
            }
        } catch (e) {
            log.error(e);
            handleServerErrors(e, () => {
                showToastError();
            })


        }
    }

    function showToastError() {
        toast.error("There has been an error. Please try again", {
            position: "top-right",
        });
    }
    function onChangeCodeValueList(opt, setFieldValue) {
        setFieldValue("codeValueList", [opt]);
        if (!opt) {
            setFieldValue("codeValue", "");
        }
    }

    function handleOnChangeAtr(id, value) {
        log.debug(id, value);
        setAttrs({
            ...attrs,
            [id]: value,
        });
    }

    function handleOnChageCodeType(e, setFieldValue) {
        onChangeCodeValueList(e.target, setFieldValue);
    }

    function onChangeFilmRelease(option, setFieldValue ) {
        setFieldValue("filmRelease", option);
        if (!option) {
            setContacts([]);
            setFieldValue("contactID", null);
            setFilmRelease(null);
        }

        if (option && option.value)
            AdvertisingService.getFilmReleaseById(option.value)
                .then((response) => {
                    setFilmRelease(response.data);
                    setContacts(response.data.contacts);
                })
                .catch((err) => log.debug(err));
    }

    function onAdvDeleted(resetForm) {
        handleFullScreenClose(resetForm);
    }

    const loadFilmReleaseId = filmRelease ? filmRelease.id : defaultFilmRelease ? defaultFilmRelease.id : null;
    return (
        (<Fragment>
            <Formik
                innerRef={formRef}
                enableReinitialize
                initialValues={initValues}
                validate={(values) => {
                    if (editing && !formChanged) {
                        setFormChanged(true);
                    }

                    const requiredMsg = "This field is required";
                    const errors = {};
                    if (editing && !values.filmRelease && (!initValues || !initValues.filmRelease)) {
                        errors.filmRelease = requiredMsg;
                    }
                    if (!values.advertisementType && (!initValues || !initValues.advertisementTypeID)) {
                        errors.advertisementType = requiredMsg;
                    }

                    if (isNaN(values.quantity)) {
                        errors.quantity = "Only numbers";
                    }
                    log.debug("saving avd validation", errors);
                    return errors;
                }}
                onSubmit={handleOnSubmit}
            >
                {({ submitForm, resetForm }) => {
                    const btns = (
                        <>
                            {initValues.id && (
                                <DeleteAdvBtn
                                    btnProps={{ style: { marginRight: 10 }, variant: "outlined" }}
                                    advId={initValues.id}
                                    onAdvDeleted={() => onAdvDeleted(resetForm)}
                                    advName={initValues.name}
                                />
                            )}
                            {initValues.id && (
                                <AddNewAdvFromExisting
                                    advId={initValues.id}
                                    onClick={() => resetFormCallback(resetForm)}
                                    style={{ marginRight: 10 }}
                                />
                            )}
                            {initValues.id && (
                                <AddNewAdvFromExisting
                                    advId={initValues.id}
                                    onClick={() => cloneFormCallback(resetForm)}
                                    style={{ marginRight: 10 }}
                                    labelText="CLONE"
                                />
                            )}
                            <Button
                                size={"small"}
                                style={{ marginRight: 10 }}
                                onClick={handleOnAddToReport}
                                color={"secondary"}
                                variant={"outlined"}
                            >
                                Save and Report
                            </Button>
                            <Button variant={"contained"} size={"small"} color={"secondary"} onClick={submitForm}>
                                Save
                            </Button>
                        </>
                    );
                    return (
                        (<FullScreenModal
                            btns={btns}
                            title={`${!editing ? "ADD" : "EDIT"} ADVERTISING`}
                            open={advertisingFormOpen}
                            handleClose={() => handleFullScreenClose(resetForm)}
                        >
                            <React.Fragment>
                                <Container maxWidth="xl">
                                    <div style={{ padding: 20, position: "relative" }}>
                                        {!editing && (
                                            <div style={{ marginBottom: 5 }}>
                                                <Field name="filmRelease">
                                                    {({ field, form }) => {
                                                        const { touched, errors } = form;
                                                        return (
                                                            <React.Fragment>
                                                                <FilmReleaseSelect2
                                                                    value={
                                                                        editing && field.value === ""
                                                                            ? initValues.filmRelease
                                                                            : field.value
                                                                    }
                                                                    onChange={(option) => onChangeFilmRelease(option, form.setFieldValue)}
                                                                    defaultOptions={
                                                                        editing && !field.value
                                                                            ? [initValues.filmRelease]
                                                                            : null
                                                                    }
                                                                    className={
                                                                        errors.filmRelease && touched.filmRelease
                                                                            ? "error"
                                                                            : ""
                                                                    }
                                                                    formikBag={form}
                                                                />
                                                                {errors.filmRelease && touched.filmRelease && (
                                                                    <small className="error" style={{ color: "red" }}>
                                                                        {errors.filmRelease}
                                                                    </small>
                                                                )}
                                                            </React.Fragment>
                                                        );
                                                    }}
                                                </Field>
                                            </div>
                                        )}
                                        <FilmCardView
                                            expandPanelClassName={"root"}
                                            defaultExpanded={false}
                                            loadFilmReleaseId={loadFilmReleaseId}
                                            filmRelease={filmRelease}
                                        />
                                        <Form>
                                            <div id="add-advertising-form">
                                                <Paper style={{ width: "100%", padding: "10px 20px", marginBottom: 5 }}>
                                                    <Grid2 container columnSpacing={8} direction={"row"}>
                                                        <Grid2
                                                            container
                                                            columnSpacing={4}
                                                            direction={"column"}
                                                            size={{
                                                                xs: 12,
                                                                lg: 6
                                                            }}>
                                                            <Grid2>
                                                                <Typography
                                                                    variant={"subtitle2"}
                                                                    className={"headerForm"}
                                                                >
                                                                    Name
                                                                </Typography>
                                                                <Field name="name">
                                                                    {({ field }) => (
                                                                        <TextField
                                                                            className="form-control"
                                                                            margin="normal"
                                                                            variant="outlined"
                                                                            label="Name"
                                                                            {...field}
                                                                            value={
                                                                                editing && !field.value
                                                                                    ? initValues.name
                                                                                    : field.value
                                                                            }
                                                                            slotProps={{
                                                                                inputLabel: {
                                                                                    shrink: false
                                                                                }
                                                                            }}
                                                                            sx={{ "& .MuiInputLabel-root": { display: "none" } }}
                                                                        />
                                                                    )}
                                                                </Field>
                                                            </Grid2>

                                                            <Grid2 container>
                                                                <Grid2
                                                                    size={{
                                                                        xs: 12,
                                                                        sm: 6
                                                                    }}>
                                                                    <Typography
                                                                        variant={"subtitle2"}
                                                                        className={"headerForm"}
                                                                    >
                                                                        Type
                                                                    </Typography>
                                                                    <Field name="advertisementType">
                                                                        {({
                                                                            field,
                                                                            form: { touched, errors, setFieldValue },
                                                                        }) => {
                                                                            // eslint-disable-next-line no-unused-vars
                                                                            const { onChange, ...restField } = field;
                                                                            return (
                                                                                <React.Fragment>
                                                                                    <Select
                                                                                        placeholder="Select type"
                                                                                        onChange={(option) =>
                                                                                            setFieldValue(
                                                                                                "advertisementType",
                                                                                                option
                                                                                            )
                                                                                        }
                                                                                        {...restField}
                                                                                        value={
                                                                                            field.value ||
                                                                                            advTypes.find(
                                                                                                (advType) =>
                                                                                                    advType.value ===
                                                                                                    initValues.advertisementTypeID
                                                                                            )
                                                                                        }
                                                                                        options={advTypes}
                                                                                        className={
                                                                                            errors.advertisementType &&
                                                                                            touched.advertisementType
                                                                                                ? "error"
                                                                                                : ""
                                                                                        }
                                                                                        defaultMenuPortalTarget
                                                                                    />
                                                                                    {errors.advertisementType &&
                                                                                        touched.advertisementType && (
                                                                                        <small className="error">
                                                                                            {
                                                                                                errors.advertisementType
                                                                                            }
                                                                                        </small>
                                                                                    )}
                                                                                </React.Fragment>
                                                                            );
                                                                        }}
                                                                    </Field>
                                                                </Grid2>
                                                                <Grid2
                                                                    container
                                                                    size={{
                                                                        xs: 12,
                                                                        sm: 6
                                                                    }}>
                                                                    <Grid2 size={6}>
                                                                        <Typography
                                                                            variant={"subtitle2"}
                                                                            className={"headerForm"}
                                                                        >
                                                                            Qt
                                                                        </Typography>
                                                                        <Field name="quantity">
                                                                            {({ field, form: { setFieldValue } }) => {
                                                                                return (
                                                                                    <TextField
                                                                                        type={"number"}
                                                                                        variant={"outlined"}
                                                                                        placeholder={"#"}
                                                                                        {...field}
                                                                                        onChange={(e) =>
                                                                                            setFieldValue(
                                                                                                "quantity",
                                                                                                e.target.value
                                                                                            )
                                                                                        }
                                                                                        value={field.value}
                                                                                    />
                                                                                );
                                                                            }}
                                                                        </Field>
                                                                    </Grid2>
                                                                    <Grid2 size={6}>
                                                                        <Typography
                                                                            variant={"subtitle2"}
                                                                            className={"headerForm"}
                                                                        >
                                                                            Length
                                                                        </Typography>

                                                                        <TextAtr
                                                                            attr={attrs[ATTRIBUTE_TYPE_IDS.LENGTH]}
                                                                            endAdornment={
                                                                                <InputAdornment position="end">
                                                                                    sec
                                                                                </InputAdornment>
                                                                            }
                                                                            onChange={handleOnChangeAtr}
                                                                            label={"Length"}
                                                                            id={ATTRIBUTE_TYPE_IDS.LENGTH}
                                                                            notched={false}
                                                                        />
                                                                    </Grid2>
                                                                </Grid2>
                                                                {editing ? (
                                                                    <Grid2
                                                                        style={{ paddingTop: 0 }}
                                                                        size={{
                                                                            xs: 12,
                                                                            md: 12
                                                                        }}>
                                                                        <RelatedTable
                                                                            associations={
                                                                                associations ? associations : []
                                                                            }
                                                                            advId={advId ? advId : null}
                                                                            changeAssociations={setAssociations}
                                                                        />
                                                                    </Grid2>
                                                                ) : null}
                                                            </Grid2>
                                                        </Grid2>
                                                        <Grid2
                                                            container
                                                            size={{
                                                                xs: 12,
                                                                lg: 6
                                                            }}>

                                                            <Grid2 container size={12}>

                                                                    <Grid2 size={4}>
                                                                        <div style={{ width: 100, height: 20 }} />

                                                                        <BooleanAtr
                                                                            attr={attrs[ATTRIBUTE_TYPE_IDS.FINAL]}
                                                                            onChange={handleOnChangeAtr}
                                                                            label={"Final"}
                                                                            id={ATTRIBUTE_TYPE_IDS.FINAL}
                                                                        />
                                                                    </Grid2>
                                                                    <Grid2 size={4}>
                                                                        <div style={{ width: 100, height: 20 }} />
                                                                        <Field name="advReported">
                                                                            {({ field }) => (
                                                                                <Grid2
                                                                                    size={{
                                                                                        xs: 12,
                                                                                        lg: 3,
                                                                                        sm: 6
                                                                                    }}>
                                                                                    <FormControlLabel
                                                                                        control={
                                                                                            <GreenCheckbox
                                                                                                {...field}
                                                                                                checked={reported}
                                                                                                onChange={(e) =>
                                                                                                    setReported(
                                                                                                        e.target.checked
                                                                                                    )
                                                                                                }
                                                                                            />
                                                                                        }
                                                                                        label="Reported"
                                                                                    />
                                                                                </Grid2>
                                                                            )}
                                                                        </Field>
                                                                    </Grid2>
                                                                    <Grid2 size={4}>
                                                                        <div style={{ width: 100, height: 20 }} />
                                                                        <Field name="advException">
                                                                            {({ field }) => (
                                                                                <Grid2
                                                                                    size={{
                                                                                        xs: 12,
                                                                                        lg: 3,
                                                                                        sm: 6
                                                                                    }}>
                                                                                    <FormControlLabel
                                                                                        control={
                                                                                            <RedCheckbox
                                                                                                {...field}
                                                                                                checked={exception}
                                                                                                onChange={(e) =>
                                                                                                    setException(
                                                                                                        e.target.checked
                                                                                                    )
                                                                                                }
                                                                                            />
                                                                                        }
                                                                                        label="Exception"
                                                                                    />
                                                                                </Grid2>
                                                                            )}
                                                                        </Field>
                                                                    </Grid2>

                                                            </Grid2>
                                                            <Grid2 container size={12}>
                                                                <Grid2 size={12}>
                                                                    <div style={{ width: 100, height: 5 }} />
                                                                </Grid2>
                                                                <Grid2 size={3}>
                                                                    <Typography
                                                                        variant={"subtitle2"}
                                                                        className={"headerForm"}
                                                                    >
                                                                        LEQ
                                                                    </Typography>
                                                                    <TextAtr
                                                                        attr={attrs[ATTRIBUTE_TYPE_IDS.LEQ]}
                                                                        variant={"outlined"}
                                                                        type={"number"}
                                                                        onChange={handleOnChangeAtr}
                                                                        label={"LEQ"}
                                                                        id={ATTRIBUTE_TYPE_IDS.LEQ}
                                                                        notched={false}
                                                                    />
                                                                </Grid2>
                                                                <Grid2 size={5}>
                                                                    <Typography
                                                                        variant={"subtitle2"}
                                                                        className={"headerForm"}
                                                                    >
                                                                        Ad Code
                                                                    </Typography>
                                                                    <Field name="codeValue">
                                                                        {({
                                                                            field,
                                                                            form: { values, setFieldValue },
                                                                        }) => {
                                                                            return (
                                                                                <OutlinedInput
                                                                                    placeholder={"Type code"}
                                                                                    {...field}
                                                                                    value={field.value}
                                                                                    startAdornment={
                                                                                        <InputAdornment position="start">
                                                                                            <span
                                                                                                style={{
                                                                                                    width: 50,
                                                                                                    marginLeft: -5,
                                                                                                    marginTop: 1
                                                                                                }}
                                                                                            >
                                                                                                <CodeSelection
                                                                                                    filmCodeTypes={
                                                                                                        filmCodeTypes
                                                                                                    }
                                                                                                    initValues={
                                                                                                        initValues
                                                                                                    }
                                                                                                    codeListValue={
                                                                                                        values.codeValueList
                                                                                                    }
                                                                                                    onChange={(e) =>
                                                                                                        handleOnChageCodeType(
                                                                                                            e,
                                                                                                            setFieldValue
                                                                                                        )
                                                                                                    }
                                                                                                />
                                                                                            </span>
                                                                                        </InputAdornment>
                                                                                    }
                                                                                />
                                                                            );
                                                                        }}
                                                                    </Field>
                                                                </Grid2>
                                                            </Grid2>
                                                            <Grid2 container size={12}>
                                                                <Grid2 size={8}>
                                                                    <div style={{ width: 100, height: 15 }} />
                                                                    <Typography
                                                                        variant={"subtitle2"}
                                                                        className={"headerForm"}
                                                                    >
                                                                        Contact
                                                                    </Typography>

                                                                    <Field name="contact">
                                                                        {({ field, form: { setFieldValue } }) => {
                                                                            // eslint-disable-next-line no-unused-vars
                                                                            const { onChange, ...restField } = field;
                                                                            return (
                                                                                <Select
                                                                                    placeholder="Select contact"
                                                                                    onChange={(option) => {
                                                                                        setFieldValue(
                                                                                            "contact",
                                                                                            option
                                                                                        );
                                                                                    }}
                                                                                    {...restField}
                                                                                    value={
                                                                                        field.value ||
                                                                                        initValues.contact
                                                                                    }
                                                                                    defaultMenuPortalTarget
                                                                                    options={
                                                                                        contacts.length
                                                                                            ? contacts.map(
                                                                                                (contact) => ({
                                                                                                    value: contact.id,
                                                                                                    label: `${contact.firstName} ${contact.lastName}`,
                                                                                                })
                                                                                            )
                                                                                            : initValues.contacts
                                                                                    }
                                                                                />
                                                                            );
                                                                        }}
                                                                    </Field>
                                                                </Grid2>
                                                            </Grid2>
                                                        </Grid2>
                                                    </Grid2>
                                                </Paper>
                                            </div>
                                        </Form>
                                        <AddReviewForm
                                            ref={reviewFormRef}
                                            outlined
                                            onChange={onReviewChanged}
                                            onReset={onReviewReset}
                                            review={reviewSelected}
                                        />

                                        <Accordion style={{ marginTop: 5 }}>
                                            <AccordionSummary
                                                className={classes.summary}
                                                expandIcon={<ExpandMoreIcon />}
                                            >
                                                <Typography variant="h6" style={{ fontSize: 18 }}>
                                                    Review history
                                                </Typography>
                                            </AccordionSummary>
                                            <AccordionDetails className={classes.summary}>
                                                <Grid2 container>
                                                    <Grid2
                                                        container
                                                        className="table-header"
                                                        size={{
                                                            xs: 12,
                                                            md: 12
                                                        }}>
                                                        <div style={{ width: 30 }} />

                                                        <Grid2
                                                            size={{
                                                                xs: 5,
                                                                md: 1
                                                            }}>
                                                            DATE
                                                        </Grid2>
                                                        <Grid2
                                                            size={{
                                                                xs: 6,
                                                                md: 2
                                                            }}>
                                                            REVIEWER
                                                        </Grid2>
                                                        <Grid2
                                                            size={{
                                                                xs: 6,
                                                                md: 2
                                                            }}>
                                                            STATUS
                                                        </Grid2>
                                                        <Grid2
                                                            size={{
                                                                xs: 6,
                                                                md: 3
                                                            }}>
                                                            INSTRUCTIONS
                                                        </Grid2>
                                                        <Grid2
                                                            size={{
                                                                xs: 6,
                                                                md: 3
                                                            }}>
                                                            PRIVATE NOTES
                                                        </Grid2>
                                                    </Grid2>
                                                    <Grid2
                                                        container
                                                        className="table-body"
                                                        size={{
                                                            xs: 12,
                                                            md: 12
                                                        }}>
                                                        {!reviewsToAdd.length && <h4>No reviews added yet</h4>}
                                                        {reviewsToAdd.length > 0 &&
                                                            reviewList.map((row, i) => (
                                                                <Grid2
                                                                    key={i}
                                                                    container
                                                                    className="table-item"
                                                                    size={{
                                                                        xs: 12,
                                                                        md: 12
                                                                    }}>
                                                                    <div style={{ width: 30 }}>
                                                                        <Tooltip title="Edit review" placement="right">
                                                                            <IconButton
                                                                                style={{
                                                                                    height: 30,
                                                                                    width: 30,
                                                                                }}
                                                                                size="small"
                                                                                onClick={() =>
                                                                                    setReviewSelected(reviewList[i])
                                                                                }
                                                                            >
                                                                                <EditOutlinedIcon />
                                                                            </IconButton>
                                                                        </Tooltip>
                                                                    </div>
                                                                    <Grid2
                                                                        size={{
                                                                            xs: 5,
                                                                            sm: 1
                                                                        }}>
                                                                        {}
                                                                        <div className="f-col">
                                                                            <div>
                                                                                {formatDate(row.dateEntered, DATE_FORMAT_TEXT_INPUT)}
                                                                                <br />
                                                                                {formatDate(row.dateEntered, DATE_FORMAT_HOUR_AM_PM)}
                                                                            </div>
                                                                        </div>
                                                                    </Grid2>
                                                                    <Grid2
                                                                        size={{
                                                                            xs: 6,
                                                                            sm: 2
                                                                        }}>
                                                                        <div>
                                                                            {editing &&
                                                                                row.user &&
                                                                                `${row.user.firstName} ${row.user.lastName}`}
                                                                            {!editing &&
                                                                                `${user.firstName} ${user.lastName}`}
                                                                        </div>
                                                                    </Grid2>
                                                                    <Grid2
                                                                        size={{
                                                                            xs: 6,
                                                                            sm: 2
                                                                        }}>
                                                                        <div>
                                                                            {row.reviewStatusType &&
                                                                                row.reviewStatusType.label}
                                                                        </div>
                                                                    </Grid2>
                                                                    <Grid2
                                                                        size={{
                                                                            xs: 12,
                                                                            md: 3
                                                                        }}>
                                                                        <AtsTooltip
                                                                            trigger={
                                                                                <Typography
                                                                                    className={
                                                                                        "block-ellipsis-4-lines no-padding-html-text"
                                                                                    }
                                                                                    style={{
                                                                                        paddingRight: 5,
                                                                                        width: "99%",
                                                                                        fontSize: "0.9rem",
                                                                                    }}
                                                                                    dangerouslySetInnerHTML={{
                                                                                        __html: row.instruction
                                                                                            ? row.instruction
                                                                                            : "",
                                                                                    }}
                                                                                />
                                                                            }
                                                                            content={
                                                                                <React.Fragment>
                                                                                    <Typography className={"bold600"}>
                                                                                        Instructions:{" "}
                                                                                    </Typography>
                                                                                    <Typography
                                                                                        className={
                                                                                            "no-padding-html-text"
                                                                                        }
                                                                                        dangerouslySetInnerHTML={{
                                                                                            __html: row.instruction
                                                                                                ? row.instruction
                                                                                                : "",
                                                                                        }}
                                                                                    />
                                                                                </React.Fragment>
                                                                            }
                                                                            contentStyle={{ maxWidth: 600, maxHeight: 400, overflow: "scroll" }}
                                                                        />
                                                                    </Grid2>
                                                                    <Grid2
                                                                        size={{
                                                                            xs: 12,
                                                                            md: 3
                                                                        }}>
                                                                        <AtsTooltip
                                                                            trigger={
                                                                                <Typography
                                                                                    className={
                                                                                        "block-ellipsis-4-lines no-padding-html-tex"
                                                                                    }
                                                                                    style={{
                                                                                        paddingRight: 5,
                                                                                        width: "99%",
                                                                                        fontSize: "0.9rem",
                                                                                    }}
                                                                                    dangerouslySetInnerHTML={{
                                                                                        __html: row.privateNote
                                                                                            ? row.privateNote
                                                                                            : "",
                                                                                    }}
                                                                                />
                                                                            }
                                                                            content={
                                                                                <React.Fragment>
                                                                                    <Typography className={"bold600"}>
                                                                                        Private Notes:{" "}
                                                                                    </Typography>
                                                                                    <Typography
                                                                                        className={
                                                                                            "no-padding-html-text"
                                                                                        }
                                                                                        dangerouslySetInnerHTML={{
                                                                                            __html: row.privateNote
                                                                                                ? row.privateNote
                                                                                                : "",
                                                                                        }}
                                                                                    />
                                                                                </React.Fragment>
                                                                            }
                                                                            contentStyle={{ maxWidth: 600, maxHeight: 400, overflow: "scroll" }}
                                                                        />
                                                                    </Grid2>
                                                                </Grid2>
                                                            ))}
                                                    </Grid2>
                                                </Grid2>
                                            </AccordionDetails>
                                        </Accordion>
                                    </div>
                                </Container>

                                {(addStatus === ACTION_STATES.SEND || editStatus === ACTION_STATES.SEND) && (
                                    <Backdrop style={{ color: "#fff", zIndex: 10 }} open={true}>
                                        <CircularProgress color="inherit" />
                                    </Backdrop>
                                )}
                                {confirmDialogOpen && (
                                    <ConfirmDialog
                                        open={confirmDialogOpen}
                                        message="You made changes to the advertisement"
                                        confirmText="Save"
                                        closeText="Discard"
                                        onConfirm={() => handleConfirmDialogClose(resetForm, submitForm)}
                                        onCancel={() => closeConfirmation(resetForm)}
                                    />
                                )}
                            </React.Fragment>
                        </FullScreenModal>)
                    );
                }}
            </Formik>
        </Fragment>)
    );
};

function CodeSelection({ initValues, codeListValue, filmCodeTypes, onChange }) {
    const value = assertArray(codeListValue)
        ? codeListValue[0]
        : assertArray(initValues.codeValueList)
            ? initValues.codeValueList[0]
            : null;

    const id = value ? value.value : 2;
    if (!assertArray(filmCodeTypes)) {
        return null;
    }
    return (
        <MuiSelect variant="standard" disableUnderline value={id} onChange={onChange}>
            {filmCodeTypes.map((fCode) => {
                return (
                    <MenuItem key={fCode.id} value={fCode.id} name={fCode.name}>
                        {fCode.name}
                    </MenuItem>
                );
            })}
        </MuiSelect>
    );
}
function BooleanAtr({ attr, onChange, label, checkBoxColor, id }) {
    const active = get(attr, "active", false);
    function handleActive(e) {
        onChange(id, {
            active: e.target.checked,
        });
    }

    return (
        (<Grid2 size={12}>
            <FormControlLabel
                control={<Checkbox checked={active} onChange={handleActive} color={checkBoxColor} />}
                label={label}
            />
        </Grid2>)
    );
}
function TextAtr({ attr, onChange, id, endAdornment, ...rest }) {
    const inputV = get(attr, "value", "");

    function handleInputChange(e) {
        const value = e.target.value;
        onChange(id, {
            active: assertString(value),
            value: e.target.value,
        });
    }

    return (
        <OutlinedInput
            className="form-control"
            label={null}
            type={"number"}
            margin="none"
            variant="outlined"
            endAdornment={endAdornment}
            value={inputV}
            onChange={handleInputChange}
            {...rest}
        />
    );
}

const mapStateToProps = ({
    advertising: { advertisingForm, addStatus, editStatus, details, loadingStatus },
    login: { user },
    globalApp: { attributeTypes, filmCodeTypes, advertisementTypes },
}) => ({
    attributeTypes,
    advertisementTypes,
    filmCodeTypes,
    user,
    editing: advertisingForm.editing,
    initValues: advertisingForm.values,
    advertisingFormOpen: advertisingForm.open,
    addStatus,
    editStatus,
    details,
    loadingStatus,
});

const mapDispatchToProps = (dispatch) => {
    return {
        addAdv: (values, callback) => dispatch(actions.ADD_ADV.send({ values, callback })),
        editAdv: (values, callback) => dispatch(actions.EDIT_ADV.send({ values, callback })),
        getAdvertisementTypes: () => dispatch(actions.GET_ADVERTISEMENT_TYPE.send(API_URL.advertisingAdvT())),
        getReviewsStatusTypes: () => dispatch(actions.GET_REVIEW_STATUS_TYPE.send(API_URL.advertisingRST())),
        getFilmCodeTypes: () => dispatch(actions.GET_FILM_CODE_TYPE.send(API_URL.filmCodeT())),
        getAttributeTypes: () => dispatch(globalActions.GET_ATTRIBUTE_TYPES.send()),
        getUserInfo: () => dispatch(loginActions.INFO_USER.send()),
        refreshTable: () => dispatch(actions.REFRESH_TABLE.send()),
        addToReportById: (id) => dispatch(reportAdvActions.ON_ADD_ADV_TO_REPORT_BY_ID.call({ id })),

        toggleAdvertisingForm: () => dispatch(actions.TOGGLE_ADVERTISING_FORM.send()),
        onCleanForm: () => dispatch(actions.CLEAR_ADV_FORM.call()),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(AddAdvertisingForm);
